module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/process/upload/upload.component.html
// module id = ./src/app/components/process/upload/upload.component.html
// module chunks = main